var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "detailsModal",
        size: "xl",
        "content-class": "sub-menu-bg-blue-transparent gtp-details-modal",
        title: "Ground Truth Point Details",
        "hide-footer": "",
        scrollable: "",
      },
      on: { shown: _vm.renderMap },
    },
    [
      _c(
        "div",
        { staticClass: "col-lg-12" },
        [
          _c("div", [
            _c("div", {
              staticClass: "ol-map mapGTP",
              attrs: { id: "mapGTP" },
            }),
          ]),
          _vm._v(" "),
          _c("vue-bootstrap4-table", {
            attrs: {
              rows: _vm.gtpDetailsRows,
              columns: _vm.gtpDetailsColumns,
              config: _vm.detailsConfig,
              classes: _vm.classes,
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }